export default "__VITE_PUBLIC_ASSET__9b6752c8__"